import type { ColDefField, ServerColDef } from '@cmg/data-grid';
import { formatters } from '@cmg/data-grid';

import { RolodexRecordStatus } from '../../../../../../graphql';
import { RelationshipStatusCellEditor } from './RelationshipStatusCellEditor';

type CreateRelationshipStatusColDefProps<TData> = {
  field?: ColDefField<TData, RolodexRecordStatus>;
  editable: ServerColDef['editable'];
};

export function createRelationshipStatusColDef<
  TData extends { relationshipStatus: RolodexRecordStatus }
>({
  field = 'relationshipStatus' as ColDefField<TData, RolodexRecordStatus>,
  editable,
}: CreateRelationshipStatusColDefProps<TData>): ServerColDef<TData, RolodexRecordStatus> {
  return {
    field,
    headerName: 'Relationship Status',
    editable,
    filter: 'agSetColumnFilter',
    cellEditor: RelationshipStatusCellEditor,
    valueFormatter: formatters.enumValueFormatter,
    filterParams: {
      values: Object.values(RolodexRecordStatus),
      valueFormatter: formatters.enumValueFormatter,
    },
  };
}
